module.exports = __webpack_public_path__ + "static/media/ic_atas_device.b8e58719.svg";